import {
  useGetAppointmentByCodexAppointmentIdLazyQuery,
  useGetFhirProviderByCodexIdLazyQuery,
  useGetProviderAppointmentByCodexAppointmentIdLazyQuery,
} from 'graphql/generated/remote-schema-hasura';
import { useCallback } from 'react';
import { GetAppointmentOutput } from 'graphql/generated/hasura';
import { useAuth } from 'auth/context/AuthContext';
import { Roles } from '../../../../firebase/interfaces';
import { useGetProviderData } from '../../../my-account/hooks/useGetProviderData';

export interface AppointmentDetails extends GetAppointmentOutput {
  calendarId?: string | null;
  appointmentTypeId?: string | null;
}

export const useGetAppointments = (appointmentId: string | null) => {
  const [getProvider] = useGetFhirProviderByCodexIdLazyQuery();

  const [getAppointment] = useGetAppointmentByCodexAppointmentIdLazyQuery();

  return useCallback(async (): Promise<AppointmentDetails> => {
    const appointmentData = await getAppointment({
      fetchPolicy: 'network-only',
      variables: { appointmentCodexId: String(appointmentId) },
    });
    const appointment = appointmentData.data?.getFHIRAppointmentByCodexId
      ?.appointment as GetAppointmentOutput;
    let calendarId = '';
    if (appointment.codexProviderId) {
      const providerData = await getProvider({
        variables: { codexProviderId: String(appointment.codexProviderId) },
      });
      calendarId = providerData?.data?.getFHIRProviderbyCodexIdArgument
        .providers[0]?.providers.acuityCalendarId as string;
    }

    return {
      ...appointment,
      calendarId,
    };
  }, [appointmentId, getAppointment, getProvider]);
};

export const useGetAppointmentsProviderRole = (
  appointmentId: string | null,
) => {
  const { user } = useAuth();

  const [getAppointment] =
    useGetProviderAppointmentByCodexAppointmentIdLazyQuery();
  const { providerProfileData: provider } = useGetProviderData();
  return useCallback(async (): Promise<AppointmentDetails> => {
    if (user?.role !== Roles.PROVIDER)
      return Promise.resolve({} as AppointmentDetails);
    const appointmentData = await getAppointment({
      fetchPolicy: 'network-only',
      variables: { appointmentCodexId: String(appointmentId) },
    });
    const appointment = appointmentData.data?.getFHIRAppointmentByCodexId
      ?.appointment as GetAppointmentOutput;

    return {
      ...appointment,
      calendarId: provider?.acuityCalendarId,
      providerFirstName: provider?.firstname,
      providerLastName: provider?.lastname,
    };
  }, [
    appointmentId,
    getAppointment,
    provider?.acuityCalendarId,
    provider?.firstname,
    provider?.lastname,
    user?.role,
  ]);
};
